import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { DefaultPlan } from "@modules/defaultPlans/types";

export function useDefaultPlanList({ productId }: { productId?: string } = {}) {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createDefaultPlanModalRef = useRef<ModalRef>(null);
  const editDefaultPlanModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } =
    usePaginatedTable<DefaultPlan>({
      resource: "v1/default_plan_admin",
      filters: {
        ...getQueryParams(),
        default_product: productId,
      },
    });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createDefaultPlanModalRef,
    editDefaultPlanModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
